import { InputSwitchModule } from 'primeng/inputswitch';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { first } from 'rxjs';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-helpdesk',
  templateUrl: './helpdesk.component.html',
  styleUrls: ['./helpdesk.component.scss']
})
export class HelpdeskComponent implements OnInit {

  isSubmitted = false;
  applicationId: any = null;
  inputId: any = null;
  userID: any;

  constructor(
    public router: Router,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.activityRecordService.activityRecord(this.userID, 'Application Status', '', new Date(), 'Success');
  }

  getApplicationStatus() {
    if (!this.inputId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Enter Application Id/ Aadhar No.',
      });
      return;
    }
    if(this.inputId.length == 12){
      this.getApplicationNo(this.inputId);
    }else if(this.inputId.startsWith('MI')){
      this.applicationId = this.inputId;
      this.checkApplicationDetails();
    }else{
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Enter Application Id/ Aadhar No properly.',
      });
    }
    // this.isSubmitted = false;

    this.isSubmitted = true;
  }

  getApplicationNo(aadharNo){
    this.loader.start();
    this.deptDashBoardService
      .getAppIdByAadharNo(aadharNo)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.applicationId = data[0][0]?.APP_ID;
          this.checkApplicationDetails();
          this.activityRecordService.activityRecord(this.userID, 'Get Application by Aadhar No', aadharNo, new Date(), 'Success');
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userID, 'Get Application by Aadhar No', aadharNo, new Date(), err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  checkApplicationDetails() {
    this.ngOnDestroy();
    // this.router.navigate(['helpdesk', 'home', this.applicationId]);
    if (((this.router.url.startsWith('/helpdesk')))) {
      this.router.navigate(['helpdesk', 'home', 'view'], { queryParams: { appId:this.cryptoJsService.Encrypt(this.applicationId.toString()) } });

      // this.router.navigate(['helpdesk', 'home', this.cryptoJsService.Encrypt(this.applicationId)]);
    }
    else if ((this.router.url.startsWith('/xen'))) {
      this.router.navigate(['xen', 'helpdesk', 'view'], { queryParams: { appId:this.cryptoJsService.Encrypt(this.applicationId.toString()) } });

      // this.router.navigate(['xen', 'helpdesk', this.cryptoJsService.Encrypt(this.applicationId)]);
    }
    else if ((this.router.url.startsWith('/cao'))) {
      this.router.navigate(['cao', 'helpdesk', 'view'], { queryParams: { appId:this.cryptoJsService.Encrypt(this.applicationId.toString()) } });

      // this.router.navigate(['cao', 'helpdesk', this.cryptoJsService.Encrypt(this.applicationId)]);
    }
    else if ((this.router.url.startsWith('/ew-department'))) {
      this.router.navigate(['ew-department', 'helpdesk', 'view'], { queryParams: { appId:this.cryptoJsService.Encrypt(this.applicationId.toString()) } });

      // this.router.navigate(['ew-department', 'helpdesk', this.cryptoJsService.Encrypt(this.applicationId)]);
    }
    else if ((this.router.url.startsWith('/ew-je'))) {
      this.router.navigate(['ew-je', 'helpdesk', 'view'], { queryParams: { appId:this.cryptoJsService.Encrypt(this.applicationId.toString()) } });

      // this.router.navigate(['ew-je', 'helpdesk', this.cryptoJsService.Encrypt(this.applicationId)]);
    }
    else if ((this.router.url.startsWith('/vendor'))) {
      this.router.navigate(['vendor', 'helpdesk', 'view'], { queryParams: { appId:this.cryptoJsService.Encrypt(this.applicationId.toString()) } });

      // this.router.navigate(['vendor', 'helpdesk', this.cryptoJsService.Encrypt(this.applicationId)]);
    }
    else if ((this.router.url.startsWith('/je'))) {
      this.router.navigate(['je', 'helpdesk', 'view'], { queryParams: { appId:this.cryptoJsService.Encrypt(this.applicationId.toString()) } });

      // this.router.navigate(['je', 'helpdesk', this.cryptoJsService.Encrypt(this.applicationId)]);
    }
    else if ((this.router.url.startsWith('/webadmin'))) {
      this.router.navigate(['webadmin', 'helpdesk', 'view'], { queryParams: { appId:this.cryptoJsService.Encrypt(this.applicationId.toString()) } });

      // this.router.navigate(['webadmin', 'helpdesk', this.cryptoJsService.Encrypt(this.applicationId)]);
    }
    else {
      this.router.navigate(['department', 'helpdesk', 'view'], { queryParams: { appId:this.cryptoJsService.Encrypt(this.applicationId.toString()) } });
      
      // this.router.navigate(['department', 'helpdesk', this.cryptoJsService.Encrypt(this.applicationId)]);
    }
  }

}